<div *ngIf="dataLoading" class="borrow-loading">
	<h3>LOADING BORROWED FRAMES</h3>
	<mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<p *ngIf="!dataLoading && !vendors.length" class="borrow-empty">No frames on loan in this direction.</p>

<article class="borrow-vendor" *ngFor="let vendor of vendors">
  <header class="borrow-vendor-head">
    <div class="borrow-vendor-name">{{ vendor.vendor.name }}</div>
    <div class="borrow-vendor-meta">{{ recordLabel(vendor.count) }} · {{ locationPhrase }}</div>
  </header>

  <div class="borrow-sheet">
    <div class="borrow-grid borrow-labels">
      <div>Status</div>
      <div>Image</div>
      <div>Model</div>
      <div>Color</div>
      <div>Size</div>
      <div>Type</div>
      <div>Borrowed</div>
      <div>Deposit</div>
      <div>Landed Cost</div>
      <div>Amount Due</div>
      <div>Order #</div>
      <div>Init.</div>
      <div>Action</div>
    </div>

    <div class="borrow-grid borrow-row" *ngFor="let row of vendor.rows; let odd = odd" [class.alt]="odd">
      <div class="borrow-cell borrow-status" [class.due]="row.status === 'due'" [class.done]="row.status === 'done'">
        {{ row.status === 'due' ? 'SOLD / DUE' : row.status === 'done' ? 'SETTLED' : 'ON LOAN' }}
      </div>
      <div class="borrow-cell">
        <div class="borrow-thumb">
          <img *ngIf="row.imageId && imageUrls[row.imageId] as src" [src]="src" alt="" (error)="hideImage($event)">
        </div>
      </div>
      <div class="borrow-cell">{{ row.model }}</div>
      <div class="borrow-cell">{{ row.color }}</div>
      <div class="borrow-cell">{{ row.size }}</div>
      <div class="borrow-cell">{{ row.type }}</div>
      <div class="borrow-cell">{{ row.borrowed ? (row.borrowed | date:'M/d/yy') : '—' }}</div>
      <div class="borrow-cell borrow-money">{{ row.deposit ? (row.deposit | currency) : 'NONE' }}</div>
      <div class="borrow-cell borrow-money">{{ row.landedCost != null ? (row.landedCost | currency) : '—' }}</div>
      <div class="borrow-cell borrow-money">{{ row.amountDue != null ? (row.amountDue | currency) : '—' }}</div>
      <div class="borrow-cell borrow-order">{{ row.orderNumber || '—' }}</div>
      <div class="borrow-cell borrow-initials">{{ row.initials || '—' }}</div>
      <div class="borrow-cell borrow-actions">
        <button
          *ngIf="!rentingUser"
          type="button"
          class="borrow-action"
          [attr.title]="'Send this loaned frame back to ' + returnStoreName"
          (click)="returnFrame($event, row)"
        >{{ returnLabel }}</button>
        <button *ngIf="rentingUser" type="button" class="borrow-action" (click)="returnRent($event, row)">Return</button>
      </div>
    </div>
  </div>
</article>
